const nonNullable = (value)=>value !== null && value !== undefined;

const parallel = async (limit, array, func)=>{
    const work = array.map((item, index)=>({
            index,
            item
        }));
    const processor = async (res)=>{
        const results = [];
        while(true){
            const next = work.pop();
            if (!next) {
                return res(results);
            }
            const result = await func(next.item);
            results.push({
                result: result,
                index: next.index
            });
        }
    };
    const queues = Array.from({
        length: limit
    }, ()=>new Promise(processor));
    const results = (await Promise.all(queues)).flat().sort((a, b)=>a.index < b.index ? -1 : 1).map((res)=>res.result);
    return results;
};

const toUnix = (p)=>{
    return p.replace(/\\/g, "/").replace(/(?<!^)\/+/g, "/");
};

export { nonNullable, parallel, toUnix };
